import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Stack, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useMe } from '../../../hooks/useMe'
import { saveSupportNote } from '../../../redux/parcels/async.parcelActions'
import showResponseText from '../showResponseText'

// The registry shows this to iBoxen users who may view the note. Editing is a
// separate permission, checked here.
export default function SupportNote({ parcel, onChanged }) {
  const { t } = useTranslation('parcels')
  const { t: transResponseMessage } = useTranslation('responseMessages')
  const dispatch = useDispatch()
  const { can } = useMe()
  const savedSupportNote = parcel?.support?.comment || ''
  const [supportNote, setSupportNote] = useState(savedSupportNote)
  const [savingNote, setSavingNote] = useState(false)

  // a reload of the parcel brings a new saved note; the field follows it
  useEffect(() => {
    setSupportNote(savedSupportNote)
  }, [savedSupportNote])

  const canEdit = can('editSupportNote')

  const saveNote = async () => {
    setSavingNote(true)
    let payload
    try {
      ;({ payload } = await dispatch(
        saveSupportNote({ _id: parcel._id, comment: supportNote })
      ))
    } catch (e) {
      // the request itself failed: nothing was saved, so keep the edit and unlock
      setSavingNote(false)
      return
    }
    setSavingNote(false)
    showResponseText(payload, transResponseMessage)
    await onChanged()
  }

  return (
    <Stack spacing={1}>
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {t('supportNote')}
      </Typography>
      <TextField
        multiline
        minRows={2}
        fullWidth
        size="small"
        value={supportNote}
        onChange={(e) => setSupportNote(e.target.value)}
        disabled={!canEdit || savingNote}
        inputProps={{ maxLength: 5000 }}
      />
      {canEdit && (
        <div>
          <Button
            variant="contained"
            color="iboxen"
            size="small"
            disabled={savingNote || supportNote === savedSupportNote}
            onClick={saveNote}
          >
            {t('saveNote')}
          </Button>
        </div>
      )}
    </Stack>
  )
}
